/**
 * @file event.js
 */

import {
    openNewWindow,
    openInCurrentPage,
    addEvent,
    removeEvent,
    openWebview
} from './windowEvent';

export {
    openNewWindow,
    openInCurrentPage,
    addEvent,
    removeEvent,
    openWebview
};
